import { Flex } from "@chakra-ui/react";
import React from "react";
import FamilyAdd from "./components/FamilyAdd";

function Data() {

  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <FamilyAdd
      />
    </Flex>
  );
}

export default Data;
